import request from "@/utils/request.js";
import {notificationQuery} from "@/api/messageCenter/index.js";

// 课表推送 -- 课表开课提醒，是否弹出
export async function findBeginRemind(data) {
  return notificationQuery(data)
}

// 消息--已读掉接口
export async function readMsgApi(data) {
  /*return  request({
    url: `/system/wrongQuestionCollection/nextQuestion`,
    method: 'post',
    params: data
  })*/
  return new Promise(resolve => {
    setTimeout(() => {
      resolve({
        code: 200,
        data: {
        }
      })
    },100)
  })
}

// 查询课表详情
export function findKbDetail(data) {
  switch (data.category) {
    case '3': // 查询批量课表
      return request({
        url: `/system/forward/system/class/allSchedule`,
        method: 'get',
        params: data
      })
    case '4': // 查询订单课表
      return request({
        url: `/system/forward/system/class/orderSchedule`,
        method: 'get',
        params: data
      })
    case '5': // 查询排课课程提醒
      return request({
        url: `/system/forward/system/class/schedule`,
        method: 'get',
        params: data
      })
    default:
      throw new Error('暂不支持的课表查询')
  }

}
